enum Multistore {
  SK = 'najlacnejsie-altanky.sk',
  HU = 'pavilonok-hazak.hu',
  PL = 'altany-domky.pl',
  CZ = 'altanky-domky.cz',
  AT = 'pavillon-gartenhaus.at',
}

export const useCurrentStore = () => {
  const currentStore = process.env.NEXT_PUBLIC_CURRENT_STORE as Multistore | undefined;

  return {
    SK: currentStore === Multistore.SK,
    HU: currentStore === Multistore.HU,
    PL: currentStore === Multistore.PL,
    CZ: currentStore === Multistore.CZ,
    AT: currentStore === Multistore.AT,
    currentStore,
  };
};
